import React from 'react';
import { Hero } from './Hero';
import { Capabilities } from './Capabilities';
import { CTA } from './CTA';
export function GlobalFileSystem() {
  return <div className="min-h-screen w-full bg-white" data-id="element-504">
      <Hero data-id="element-505" />
      <Capabilities data-id="element-506" />
      <CTA data-id="element-507" />
    </div>;
}